<div class="flex-column gap-2 align-items-start f-1-0" *ngIf="tableQueryTemplatesService.isEnabled">
	<!--save as default - template-->
	<a class="blue-link flex-row gap-1 align-items-center animated fadeIn"
	   *ngIf="tableQueryTemplatesService.selectedTemplate && !tableQueryTemplatesService.isSomeValueChanged && !saveAsTemplateInput"
	   (click)="tableQueryTemplatesService.toggleTemplateDefault();"
	   [ngClass]="{'fw-bold' : tableQueryTemplatesService.selectedTemplate.default}">
		<i class="far fa-check" style="color: darkseagreen;" [ngClass]="{'opacity-0' : !tableQueryTemplatesService.selectedTemplate.default}"></i>
		<i class="fa-save" [ngClass]="tableQueryTemplatesService.selectedTemplate.default ? 'fa' : 'far'"></i>
		<span>Save template as default</span>
	</a>
	<a class="blue-link flex-row gap-1 align-items-center animated fadeIn"
	   *ngIf="(!tableQueryTemplatesService.selectedTemplate || tableQueryTemplatesService.isSomeValueChanged) && !saveAsTemplateInput"
	   (click)="saveAsTemplateInput = {name: tableQueryTemplatesService.selectedTemplate?.name || '', error: ''}">
		<i class="far fa-check" style="opacity: 0;"></i><!--padder-->
		<i class="far fa-cog"></i>
		<span>Save as template</span>
	</a>
	<div class="flex-row align-items-cetner gap-1 animated fadeIn"
		 *ngIf="saveAsTemplateInput">
		<input type="text" class="f-1-0" style="min-width: 0;"
			   (keyup.enter)="saveTableQueryTemplate();"
			   [appAutoFocus]="true"
			   [ngClass]="{'validation-error' : saveAsTemplateInput.error}"
			   placeholder="Template name"
			   [(ngModel)]="saveAsTemplateInput.name">
		<btn-c style="min-width: 30px;"
			   endIcon="zmdi zmdi-check"
			   [loading]="tableQueryTemplatesService.templateActionInProcess"
			   (action)="saveTableQueryTemplate();">
		</btn-c>
		<btn-c style="min-width: 30px;"
			   endIcon="zmdi zmdi-close" color="danger"
			   variant="text"
			   [isDisabled]="tableQueryTemplatesService.templateActionInProcess"
			   (action)="saveAsTemplateInput = null;">
		</btn-c>
	</div>
</div>
